import { useEffect, useState } from "react";
import { useGetOptionAccessories } from "../../hooks/api/useGetOptionAccessories";

export const SETP_TYPE = {
  PRODUCT: "PRODUCT",
  ACCESSORIES: "ACCESSORIES",
  REVIEW: "REVIEW",
};

export const DEFAULT_STEPS = [
  {
    type: SETP_TYPE.PRODUCT,
    link: ``,
  },
  {
    type: SETP_TYPE.ACCESSORIES,
    link: `accessories`,
  },
  {
    type: SETP_TYPE.REVIEW,
    link: `review`,
  },
];

export const useOrderPageSteps = () => {
  const { data, isFetched } = useGetOptionAccessories();
  const [steps, setSteps] = useState([...DEFAULT_STEPS]);

  useEffect(() => {
    if (!isFetched) return;
    // Check If its enable or not
    if (data.enable_accessories_for_order) return;
    setSteps([DEFAULT_STEPS[0], DEFAULT_STEPS[2]]);
  }, [isFetched, data?.enable_accessories_for_order]);

  const findNextStep = (type) => {
    const currStepIndex = steps.findIndex((el) => el.type === type);

    return steps[currStepIndex + 1];
  };
  const findPrvStep = (type) => {
    const currStepIndex = steps.findIndex((el) => el.type === type);

    return steps[currStepIndex - 1];
  };

  return {
    steps,
    findNextStep,
    findPrvStep,
  };
};
